/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import Headerabout from '../../components/Headerabout'
import HeaderImage2 from '../../images/header_bg_3.jpg'


import './gallary.css'
function Gallry() {
  const gallaryArr =15;
  const images = [];
  for(let i = 1 ; i<=gallaryArr ;i++) {
    images.push(require(`../../images/gallery${i}.jpg`))
  }

  return (
    <>
    <Headerabout title='our gallary' image = {HeaderImage2}>
      Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Quam esse ullam tenetur quas numquam ipsam?
    </Headerabout>
    <section className="gallary">
      <div className="container gallery_container">
        {
          images.map((image,index)=>{
            return <article key={index}>
              <img src={image} alt={`Gallery Image ${index + 1}`} />
            </article>
          })
        }
      </div>
    </section>

    
    </>
  )
}

export default Gallry
